import { useState, useCallback } from "react"
import {
  connectGoogleCalendar,
  connectMicrosoftCalendar,
  disconnectGoogle,
  disconnectMicrosoft,
  isGoogleConnected,
  isMicrosoftConnected,
} from "@/modules/Calendar/service/CalendarService"

export function useCalendarIntegration() {
  const [googleConnected, setGoogleConnected] = useState<boolean>(isGoogleConnected)
  const [microsoftConnected, setMicrosoftConnected] = useState<boolean>(isMicrosoftConnected)
  const [loadingGoogle, setLoadingGoogle] = useState(false)
  const [loadingMicrosoft, setLoadingMicrosoft] = useState(false)

  const handleConnectGoogle = useCallback(async () => {
    setLoadingGoogle(true)
    try {
      await connectGoogleCalendar()
      setGoogleConnected(true)
    } finally {
      setLoadingGoogle(false)
    }
  }, [])

  const handleConnectMicrosoft = useCallback(async () => {
    setLoadingMicrosoft(true)
    try {
      await connectMicrosoftCalendar()
      setMicrosoftConnected(true)
    } finally {
      setLoadingMicrosoft(false)
    }
  }, [])

  const handleDisconnectGoogle = useCallback(() => {
    disconnectGoogle()
    setGoogleConnected(false)
  }, [])

  const handleDisconnectMicrosoft = useCallback(() => {
    disconnectMicrosoft()
    setMicrosoftConnected(false)
  }, [])

  return {
    googleConnected,
    microsoftConnected,
    loadingGoogle,
    loadingMicrosoft,
    connectGoogle: handleConnectGoogle,
    connectMicrosoft: handleConnectMicrosoft,
    disconnectGoogle: handleDisconnectGoogle,
    disconnectMicrosoft: handleDisconnectMicrosoft,
  }
}
